import { render, staticRenderFns } from "./SegmentBreakdownReport.vue?vue&type=template&id=1a87cfea"
import script from "./SegmentBreakdownReport.vue?vue&type=script&lang=js"
export * from "./SegmentBreakdownReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports